"use client"
/* */
const tableContainer = "flow--table--table-container";
const table = "flow--table";
const column = "flow--table--column";
const cell = "flow--table--cell";
const header = "flow--table--header";
const body = "flow--table--body";
const row = "flow--table--row";
const footer = "flow--table--footer";
const styles = {
	tableContainer: tableContainer,
	table: table,
	column: column,
	cell: cell,
	"horizontal-align-center": "flow--table--horizontal-align-center",
	"horizontal-align-end": "flow--table--horizontal-align-end",
	header: header,
	body: body,
	row: row,
	footer: footer,
	"vertical-align-middle": "flow--table--vertical-align-middle"
};

export { body, cell, column, styles as default, footer, header, row, table, tableContainer };
//# sourceMappingURL=Table.module.scss.mjs.map
